var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 1.414,
  clipRule: "evenodd",
  viewBox: "0 0 21 21",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#4b6475",
  clipPath: "url(#settings_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "m16.796 2.372-.255 1.338q.491.445.904.946l1.347-.202.746 1.208-.78 1.124q.262.598.438 1.224l1.318.367.195 1.407-1.181.719a9 9 0 0 1-.096 1.282l1.066.88-.394 1.364-1.384.174a9 9 0 0 1-.604 1.112l.626 1.26-.914 1.083-1.353-.408a9 9 0 0 1-.983.76l.062 1.422-1.272.617-1.086-.938a9 9 0 0 1-1.187.287l-.529 1.342-1.415.046-.614-1.308a9 9 0 0 1-1.192-.218l-1.03 1.018-1.312-.538-.03-1.451a11 11 0 0 1-.508-.325 7 7 0 0 1-.489-.357l-1.359.513-.982-1.025.562-1.336a9 9 0 0 1-.639-1.027l-1.441-.088-.481-1.337 1.05-.985a9 9 0 0 1-.172-1.212l-1.271-.663.103-1.416 1.342-.469a9 9 0 0 1 .342-1.198l-.881-1.106.668-1.254 1.398.117q.377-.519.811-.969l-.35-1.356 1.119-.869 1.21.667a9 9 0 0 1 1.156-.563L7.301.668l1.377-.34.83 1.094q.645-.068 1.297-.045l.754-1.14 1.395.25.309 1.328q.619.2 1.213.494l1.147-.731zM6.647 16.088a6.79 6.79 0 0 0 9.447-1.807c2.109-3.117 1.3-7.358-1.805-9.473a6.8 6.8 0 0 0-9.453 1.813c-2.108 3.116-1.3 7.358 1.811 9.467"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.433,
  cy: 10.511,
  r: 3.5
}))));
export default SvgSettings;